import {Bubbles} from '@management-ui/core';
import {withTheme} from '@mui/styles';
import React from 'react';
import withAccountFormStatuses from './withAccountFormStatuses';

const AccountFormStatus = ({form, statuses}) => (
  <Bubbles bubbles={statuses.filter(({key}) => key === form.status).map(({title, colour}) => (
    {
      id: 0,
      label: title,
      colour: colour
    }
  ))}/>
);

export default withAccountFormStatuses(withTheme(AccountFormStatus));
